





































import EngageContactInterface from "@/interfaces/engageContact.interface";
// @ts-ignore
import i18n from "@/libs/i18n";
import luxon from "@/libs/luxon";
import { CampaignStats } from "@/types/campaign.types";
import { MessageStatusType } from "@/types/messageStatus.type";
import { downloadCsv } from "@/utils/download";
import { PropType } from "@vue/composition-api";
import { BButton } from "bootstrap-vue";
import * as csv from "csv-stringify";
// @ts-ignore
import RadialProgressBar from "vue-radial-progress";

export default {
    components: {
        RadialProgressBar,
        BButton,
    },
    props: {
        header: {
            type: String,
            required: true,
        },
        activeCampaignContacts: {
            type: Array,
            required: true,
        },
        campaignStats: {
            type: Object as PropType<CampaignStats>,
            required: true,
        },
    },
    setup(props: { header: string; stats: CampaignStats; activeCampaignContacts: EngageContactInterface[] }) {
        const downloadUndeliveredContactsCsv = () => {
            const undeliveredContacts: EngageContactInterface[] = props.activeCampaignContacts
                .filter(
                    (campaignContact: EngageContactInterface) =>
                        campaignContact.contact.allowSystemMessages &&
                        (!campaignContact.entry ||
                            campaignContact.entry?.status === MessageStatusType.SENT ||
                            campaignContact.entry?.status === MessageStatusType.PENDING ||
                            campaignContact.entry?.status === MessageStatusType.DECLINED)
                )
                .map((campaignContact: EngageContactInterface) => {
                    return {
                        name: campaignContact.contact?.name || "",
                        email: campaignContact.contact?.email || "",
                        phone: campaignContact.contact?.phone || "",
                        reason: campaignContact.entry?.statusReason
                            ? i18n.t(`status-reasons.${campaignContact.entry?.statusReason}`)
                            : campaignContact.entry?.status
                            ? i18n.t(`message-status.${campaignContact.entry?.status}`)
                            : i18n.t("status-reasons.waiting-to-be-sent"),
                    };
                });

            csv.stringify(
                undeliveredContacts,
                {
                    delimiter: ",",
                    columns: ["name", "email", "phone", "reason"],
                    header: true,
                },
                (error, csvAsString) => {
                    if (error) {
                        throw error;
                    }

                    const today = luxon.DateTime.now().toUTC().toFormat("yyyymmdd-HHmm").toString();
                    downloadCsv(csvAsString, `engage-campaign-undelivered-${today}.csv`);
                }
            );
        };

        return {
            downloadUndeliveredContactsCsv,
        };
    },
};
